import { useLocation } from "react-router-dom";

import ProtectedRoute from "../../ProtectedRoute";

import { RouteErrorBoundary } from "./index";

const ProtectedRouteWithErrorBoundary = ({
	permissions,
	isInclusive,
	children,
	resourceName,
	validateId,
	checkExistence
}) => {
	const location = useLocation();

	const getParentPath = () => {
		const pathSegments = location.pathname.split("/").filter(Boolean);
		
		const lastSegment = pathSegments[pathSegments.length - 1];
		const secondLastSegment = pathSegments[pathSegments.length - 2];
		
		if (
			(lastSegment && !isNaN(lastSegment)) || 
			(secondLastSegment && secondLastSegment.toLowerCase().includes("id"))
		) {
			return "/" + pathSegments.slice(0, -1).join("/");
		}
		
		// Special case for paths like "/settings/groups/:groupId/users"
		// We want to go back to "/settings/groups"
		if (pathSegments.length >= 3) {
			const thirdLastSegment = pathSegments[pathSegments.length - 3];
			if (thirdLastSegment === "groups" || thirdLastSegment === "roles" || thirdLastSegment === "plugins") {
				return "/" + pathSegments.slice(0, 2).join("/");
			}
		}

		return location.pathname;
	};
	
	return (
		<ProtectedRoute permissions={permissions} isInclusive={isInclusive}>
			<RouteErrorBoundary 
				parentPath={getParentPath()}
				resourceName={resourceName}
				validateId={validateId}
				checkExistence={checkExistence}
			>
				{children}
			</RouteErrorBoundary>
		</ProtectedRoute>
	);
};

export default ProtectedRouteWithErrorBoundary;